import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CTAButton } from './CTAButton';
import { GoldDivider } from './GoldDivider';
const faqs = [{
  q: '¿Cómo recibo los archivos?',
  a: 'Inmediatamente después de pagar por MercadoPago, recibís un email con los 8 archivos PDF descargables. En tu celular, computadora o tablet. Sin esperas. Sin trámites. En menos de 5 minutos tenés todo.'
}, {
  q: '¿Es seguro pagar por esta página?',
  a: 'Sí. El pago se procesa 100% a través de MercadoPago, la plataforma de pagos más usada en Argentina. Tus datos nunca pasan por nuestra página, van directo a MercadoPago. Es exactamente igual a cuando comprás en cualquier otro sitio con MP.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. Funciona tanto para quien empieza desde cero como para quien lleva años en el nicho sin resultados consistentes.'
}, {
  q: '¿Cuánto tiempo necesito por día?',
  a: '35 minutos distribuidos en 5 momentos del día. El Bono 3 incluye un protocolo de emergencia de 10 minutos para los días difíciles.'
}, {
  q: '¿Puedo imprimir los documentos?',
  a: 'Absolutamente. Lo recomendamos especialmente para el Bono 3 con los checklists diarios.'
}, {
  q: '¿Es lo mismo que Silva o los libros de Neville?',
  a: 'No. El Protocolo 24H toma los mejores elementos de cada método y los integra en un flujo de 24 horas que ninguno de esos sistemas por separado ofrece.'
}, {
  q: '¿Y si no me convence?',
  a: 'Tenés 7 días de garantía total. Un email y te devolvemos cada peso. Sin preguntas.'
}];
export function FAQSection() {
  return <SectionWrapper bgColor="bg-brand-black" data-id="element-43">
      <h2 className="font-heading text-2xl md:text-3xl text-brand-ivory text-center font-semibold" data-id="element-44">
        Preguntas frecuentes:
      </h2>

      <div className="mt-10 max-w-2xl mx-auto space-y-8" data-id="element-45">
        {faqs.map((faq, i) => <div key={i} data-id="element-46">
            <h3 className="text-brand-gold font-body font-semibold text-base md:text-lg" data-id="element-47">
              {faq.q}
            </h3>
            <p className="text-brand-muted font-body text-base leading-relaxed mt-2" data-id="element-48">
              {faq.a}
            </p>
            {i < faqs.length - 1 && <div className="mt-8" data-id="element-49">
                <div className="h-px bg-brand-gold/10" data-id="element-50" />
              </div>}
          </div>)}
      </div>

      <div className="mt-14" data-id="element-51">
        <CTAButton text="→ EMPEZAR MI PROTOCOLO 24H AHORA — $19.990" showTrust={false} data-id="element-52" />
        <p className="text-brand-muted-dark text-xs tracking-wide text-center mt-4 max-w-md mx-auto leading-relaxed" data-id="element-53">
          🔒 Pago seguro por MercadoPago — Descarga inmediata
        </p>
        <p className="text-brand-muted-dark text-xs tracking-wide text-center mt-2" data-id="element-54">
          ✓ Pago seguro · ✓ Descarga en 5 minutos · ✓ Garantía 7 días · ✓ 390
          páginas
        </p>
      </div>
    </SectionWrapper>;
}